const postCode = {
    postCodeToAddress: function (postCodeString) {
        if (!postCodeString.match(/^\d{3}-?\d{4}$/)) {
            alert("郵便番号のフォーマットが間違っています。");
            return false;
        }

        const paramList = new FormData();
        paramList.append("postCode", postCodeString);

        post.postAjaxData(
            "/searchAddress",
            paramList,
            "",
            function ({ results }) {
                if (results.length !== 0) {
                    // 都道府県の値を変更する
                    $("[name=prefectureCode] option").map(function () {
                        if ($(this).text() === results.prefecture) {
                            $(this).prop("selected", true);
                        } else {
                            $(this).prop("selected", false);
                        }
                    });

                    postCode.changePrefectureDropDownList();

                    // 市区町村の値を変更する
                    $("[name=cityId] option").map(function () {
                        if ($(this).text() === results.city) {
                            $(this).prop("selected", true);
                        } else {
                            $(this).prop("selected", false);
                        }
                    });

                    $("#address").val(results.address); // 番地
                } else {
                    alert("住所情報が取得できませんでした");
                    return false;
                }
            },
            (error) => {},
            null
        );
    },
    // 都道府県が変更されたら、ドロップダウンリストを更新する。
    changePrefectureDropDownList: function (initializeFlg = true) {
        const prefectureCode = $("[name=prefectureCode] option:selected").val();

        let firstFlg = true;
        $("[name=cityId] option").map(function () {
            if (String($(this).data("prefecture_code")) === prefectureCode) {
                $(this).show();

                if (firstFlg && initializeFlg) {
                    $(this).prop("selected", true);
                    firstFlg = false;
                }
            } else {
                $(this).hide();
                $(this).prop("selected", false);
            }
        });
    }
};

window.postCode = postCode;
